import React from 'react';
import classNames from 'classnames';

import { StagesMenuLayerItem } from '../../types';
import { MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import { createItemTypeClassGetter } from '../../styles/menu-item-type-styles';
import { createMenuItemTestDataAttributesGetter } from '../../test-data-helpers';
import LayerMenuItem from '../LayerMenuItem';

import styles from '../../styles/LeftMenu.module.scss';

const getItemTypeClass = createItemTypeClassGetter(
  MENU_ITEM_TYPE.STAGE,
  styles.stageItem,
);

const getMenuItemTestDataAttributes = createMenuItemTestDataAttributesGetter(
  'layer-menu-item',
  MENU_ITEM_TYPE.STAGE,
);

type StageMenuItemProps = {
  entry: StagesMenuLayerItem;
  className?: string;
};

const StageMenuItem: React.FC<StageMenuItemProps> = ({ entry, className }) => {
  return (
    <LayerMenuItem
      entry={entry}
      className={classNames(getItemTypeClass(entry.type), className)}
      testDataAttributes={getMenuItemTestDataAttributes(entry)} />
  );
};

export default StageMenuItem;
